'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */

import React from 'react';
import { FeLink } from '../../../components/FeLink';
import { PushDataLayerFn } from '../../../types/pushDataLayer';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { NavigationItemLevel3 } from '../types';
import { navbarLinkToUrl } from '../utils/utils';

interface LinkItemProps {
  index: number | string;
  sectionTitle: string;
  pushDataLayer: PushDataLayerFn;
}

const LinkItem: React.FC<LinkItemProps & NavigationItemLevel3> = (props) => {
  const { langPrefix, brand } = useCmsClientContext();
  const { index, sectionTitle, pushDataLayer, ...link } = props;
  const { text, href, url_target } = navbarLinkToUrl(link, {
    langPrefix,
    brand,
  });

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    pushDataLayer({
      event: 'navigate',
      component_type: 'top-nav',
      component_title: `Level 2_${sectionTitle}/${text}`,
      action: 'click',
      index: index,
    });
  };

  if (!href) {
    return null;
  }

  return (
    <div>
      <FeLink
        href={href}
        target={url_target}
        className="text-[#687076] text-[16px] hover:text-[#212529]"
        onClick={handleClick}
      >
        {text}
      </FeLink>
    </div>
  );
};

export default LinkItem;
